module.exports = __webpack_public_path__ + "static/img/role008.b719985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role008.jpg
// module id = z3Ro
// module chunks = 1